import React, { useState } from "react";
import "antd/dist/antd.css";
import "../../css/profile.css";
import HeaderText from "../../components/HeaderText";
import SubHeaderText from "../../components/SubText";
import Navbar from "../../components/Navbar";
import PlacesLocation from "../../components/PlacesLocation";
import { Switch } from "antd";
import CompleteProfileInfoArea from "../../components/CompleteProfileInfoArea";
import CardTiles from "../../components/CardTiles";
import GenericButton from "../../components/GenericButton";
import { useUpdateProfileJobCriteriaMutation } from "../../store/appSlice";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/store";
import { PROFILE_COMPLETION_FOCUS_TABS } from "../../constants/stringConstants";
import { isEmpty } from "lodash";
import { LatLngType } from "../../interfaces/commons";
import Location from "../../assets/images/bx-location-plus.svg";
import RemoteWork from "../../assets/images/remoteWork.png";
import JobTypes from "../../assets/images/jobTypes.png";
import DesiredJobTypeMap from "./DesiredJobTypeMap";

const tiles = [
  { id: 0, text: "Full time" },
  { id: 1, text: "Part time" },
  { id: 2, text: "Short-term" },
  { id: 3, text: "Project/Freelance" },
];

function DesiredJobType() {
  const [latLng, setLatLng] = useState<LatLngType>({ lat: 0, lng: 0 });
  const [locationAddress, setLocationAddress] = useState<string>();
  const { user } = useAppSelector((state) => state["user"]);
  const [isRemote, setRemote] = useState<boolean>(false);
  const [selectedJobTypes, setSelectedJobTypes] = useState<Array<string>>([]);
  const [updateProfileJobCriteria, { data: userData, isSuccess }] =
    useUpdateProfileJobCriteriaMutation();

  const [error, setError] = useState({
    location: "",
  });

  const navigate = useNavigate();

  const getLatLngAndAddress = (latLng: LatLngType, address: string) => {
    console.log(latLng);
    setLatLng(latLng);
    setLocationAddress(address);
  };

  const asterikSign = () => (
    <h2
      style={{
        marginTop: -20,
        color: "red",
        fontSize: "20px",
        marginLeft: 5,
      }}
    >
      {" "}
      *
    </h2>
  );

  const onLocationTextChange = (e: any) => {
    console.log(e.target.value);
    setLocationAddress(e.target.value);
  };

  const onSelectRemote = () => {
    setRemote(!isRemote);
  };

  const selectListItem = (title: string) => {
    let tempJobTypes = [...selectedJobTypes];
    if (selectedJobTypes.includes(title)) {
      const newArray = tempJobTypes.filter(function (item) {
        return item != title;
      });
      setSelectedJobTypes(newArray);
    } else {
      const newArray = [...tempJobTypes, title];
      setSelectedJobTypes(newArray);
    }
  };

  const onContinue = (e: React.MouseEvent<HTMLElement>) => {
    if (isEmpty(locationAddress)) {
      let location = "Please select your desired location";
      setError({
        ...error,

        location,
      });
    } else if (!isEmpty(locationAddress) && latLng.lat === 0) {
      let location = "Select location from the list";
      setError({
        ...error,

        location,
      });
    } else {
      let data = {
        isRemote,
        jobType: selectedJobTypes,
        location: latLng,
      };

      const payload = {
        ...data,
        param: user?.id ?? "",
      };

      console.log({ payload });

      updateProfileJobCriteria(payload)
        .unwrap()
        .then((incomingData) => {
          console.log({ incomingDataInner: incomingData });
          navigate("/profile/job_related_info");
        })
        .catch((err) => {});
    }
  };

  const errorSec = (err: string) => (
    <div style={{ marginTop: "-20px" }}>
      <text style={{ color: "red" }}>{err}</text>
    </div>
  );

  return (
    <div className="profile__container">
      <Navbar />
      <div style={{ marginTop: 70 }} />

      <CompleteProfileInfoArea
        focusTab={PROFILE_COMPLETION_FOCUS_TABS.JOB_DETAILS}
      />

      {/* 1st screen */}
      <div style={{ width: "100%", flexDirection: "row", display: "flex" }}>
        <div className="profile_sec_container">
          <div className="dream_location_container">
            <div className="header_text_screen2">
              <HeaderText text={"What is your dream job location?"} />
              <SubHeaderText
                text={
                  "You can always change these preferences from profile settings later."
                }
              />
            </div>

            <div style={{ marginBottom: "5rem" }}>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",

                  marginBottom: 6,
                }}
              >
                <p
                  style={{ marginBottom: "3rem" }}
                  className="complete_profile_input_fields_heading"
                >
                  Location
                </p>
                {asterikSign()}
              </div>
              <div style={{ width: "60%" }}>
                <PlacesLocation
                  getLocationLatLngAndAddress={getLatLngAndAddress}
                  locationAddress={locationAddress}
                  onLocationTextChange={onLocationTextChange}
                  setLatLng={setLatLng}
                  hasError={!isEmpty(error.location)}
                />
              </div>
              <div style={{ marginTop: 75 }}>
                {!isEmpty(error.location) && errorSec(error.location)}
              </div>
            </div>

            <div className="border_bottom_signup_process_heading"></div>

            <div className="open_for_remote">
              <p className="complete_profile_input_fields_heading">
                I am open for remote work
              </p>
              <div>
                <Switch onChange={onSelectRemote} checked={isRemote} />
              </div>
            </div>

            <div
              className="header_text_screen3"
              style={{ marginTop: "2rem", maxWidth: "440px" }}
            >
              <SubHeaderText
                text={
                  "Being open for remote work enables you to get notifications about work from home opportunities."
                }
              />
            </div>
            <div className="border_bottom_signup_process_heading"></div>
          </div>

          {/* prefer job type */}

          <div className="job_type_container">
            <div className="header_text_screen2">
              <HeaderText text={"What type of job do you prefer?"} />
              <SubHeaderText
                text={
                  "You can always change these preferences from profile settings later."
                }
              />
            </div>
            <div className="card_tiles_sec">
              {tiles.map((item) => {
                return (
                  <CardTiles
                    key={item.id}
                    id={item.id}
                    text={item.text}
                    isActive={selectedJobTypes.includes(item.text)}
                    setIsActive={(selected: string) => selectListItem(selected)}
                    getIdData={false}
                  />
                );
              })}
            </div>
          </div>
          <div className="continue_btn_container">
            <GenericButton
              onBtnClick={(e) => {
                onContinue(e);
              }}
            />
          </div>
        </div>
        <div className="showView">
          <DesiredJobTypeMap
            isRemote={isRemote}
            locationAddress={locationAddress}
            selectedJobTypes={selectedJobTypes}
          />
        </div>
      </div>
    </div>
  );
}

export default DesiredJobType;
